import { ExclamationCircleFilled } from '@ant-design/icons';
import * as React from 'react';
import OWButton from '../../../components/ow_button/OWButton';
import { cn } from '../../../utils/ClassNamesUtils';

interface OscarUnsentMessageProps {
	/**
	 * Why it failed. Empty when the connection strip is already saying why, so
	 * the same sentence does not appear twice on screen.
	 */
	reason?: string;
	/**
	 * Re-sends the message. Omit while the connection strip owns the retry —
	 * two Try again buttons doing the same thing reads as two different actions.
	 */
	onRetry?: () => void;
	className?: string;
}

/**
 * Sits under the message that did not make it out.
 *
 * A failed send used to be a line of red text in the transcript, which left the
 * user to select their own message, copy it, and paste it back into the
 * composer. The retry belongs on the message, and `useAgentChat` re-sends it
 * under its original id so this row resolves in place rather than adding a
 * second copy of the same question.
 *
 * No Figma node covers this yet — see the README.
 */
export const OscarUnsentMessage = ({ reason, onRetry, className }: OscarUnsentMessageProps) => (
	<div role="alert" className={cn('flex w-full shrink-0 items-center gap-s', className)}>
		<ExclamationCircleFilled className="shrink-0 text-character-danger" />
		<span className="bodyregular min-w-0 flex-1 text-character-secondary">
			<span className="text-character-danger">Not sent.</span>
			{reason ? ` ${reason}` : null}
		</span>
		{onRetry ? (
			<OWButton htmlType="button" size="large" onClick={onRetry} className="shrink-0">
				Try again
			</OWButton>
		) : null}
	</div>
);

export default OscarUnsentMessage;
